/**
 * @module lib/utils
 * @description Shared class-name composition utilities for the UI design system.
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines conditional class names and resolves conflicting Tailwind utilities.
 *
 * @param inputs - Class names, conditional values, or nested class-name arrays.
 * @returns A normalized class-name string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
